var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrevCalendarButton = function SvgPrevCalendarButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.25,
    transform: "rotate(-180 16 16)",
    stroke: "#4E6DF5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.622 9.957a1 1 0 0 1 1.414 0l.273.273a1 1 0 0 1 0 1.415l-4.434 4.434 4.434 4.435a1 1 0 0 1 0 1.414l-.273.273a1 1 0 0 1-1.414 0L11.5 16.08l6.122-6.122Z",
    fill: "#4E6DF5"
  })));
};
export default SvgPrevCalendarButton;